const styleSheet = () => ({
  fullscreenLoader: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translateX(-50%) translateY(-50%)",
    maxWidth: "90px",
  },
  loader: {
    maxWidth: "90px",
    margin: "0 auto",
  },
});

export default styleSheet;
